export default {
    namespaced: true,
    state: {
      showZeroTrust: false,
    },
    getters: {
  
  
  
    },
    mutations: {
      SET_ZERO_TRUST_STATE(state, value) {
        state.showZeroTrust = value
      },
    },
    actions: {},
  }
  